import React, { Component } from "react"

import Image from "../components/image"

const projectStyle = {
  borderBottom: "1px solid #313540",
  margin: "0 auto 120px",
  maxWidth: 600,
  paddingBottom: 60,
  width: "100%",

  // nested styles?
  h2: {
    fontSize: '2em',
    fontWeight: 400,
    marginBottom: 20,
    marginTop: 20
  },
}

const createMarkup = html => {
  return {
    __html: html,
  }
}

export default class Project extends Component {
  render() {
    return (
      <div style={projectStyle}>
        <Image imgsrc={this.props.image} imgalt={this.props.imageAlt} />
        <h2 style={projectStyle.h2}>{this.props.title}</h2>
        <div
          className="item-description"
          dangerouslySetInnerHTML={createMarkup(this.props.description)}
        ></div>
      </div>
    )
  }
}
